// source: proto/stockborrowpb/charge.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.stockborrowpb.Charge', null, global);
goog.exportSymbol('proto.stockborrowpb.ListChargeRequest', null, global);
goog.exportSymbol('proto.stockborrowpb.ListChargeResponse', null, global);
goog.exportSymbol('proto.stockborrowpb.ListChargeSummary', null, global);
goog.exportSymbol('proto.stockborrowpb.ProcessChargeRequest', null, global);
goog.exportSymbol('proto.stockborrowpb.ProcessChargeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.Charge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stockborrowpb.Charge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.Charge.displayName = 'proto.stockborrowpb.Charge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.ListChargeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stockborrowpb.ListChargeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.ListChargeRequest.displayName = 'proto.stockborrowpb.ListChargeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.ListChargeSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stockborrowpb.ListChargeSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.ListChargeSummary.displayName = 'proto.stockborrowpb.ListChargeSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.ListChargeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stockborrowpb.ListChargeResponse.repeatedFields_, null);
};
goog.inherits(proto.stockborrowpb.ListChargeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.ListChargeResponse.displayName = 'proto.stockborrowpb.ListChargeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.ProcessChargeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stockborrowpb.ProcessChargeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.ProcessChargeRequest.displayName = 'proto.stockborrowpb.ProcessChargeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stockborrowpb.ProcessChargeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stockborrowpb.ProcessChargeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stockborrowpb.ProcessChargeResponse.displayName = 'proto.stockborrowpb.ProcessChargeResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.Charge.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.Charge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.Charge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.Charge.toObject = function(includeInstance, msg) {
  var f, obj = {
    stockBorrowId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    firstBorrowDate: (f = msg.getFirstBorrowDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 5, ""),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 9, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 10, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 11, ""),
    rate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    fee: jspb.Message.getFieldWithDefault(msg, 13, ""),
    dateType: jspb.Message.getFieldWithDefault(msg, 15, ""),
    fromTradeDate: (f = msg.getFromTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toTradeDate: (f = msg.getToTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    marketValue: jspb.Message.getFieldWithDefault(msg, 18, ""),
    status: jspb.Message.getFieldWithDefault(msg, 19, ""),
    rateSource: jspb.Message.getFieldWithDefault(msg, 20, ""),
    closingPrice: jspb.Message.getFieldWithDefault(msg, 21, ""),
    tdQty: jspb.Message.getFieldWithDefault(msg, 22, ""),
    sdQty: jspb.Message.getFieldWithDefault(msg, 23, ""),
    previousRate: jspb.Message.getFieldWithDefault(msg, 24, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 25, ""),
    rateId: jspb.Message.getFieldWithDefault(msg, 26, 0),
    showClientRate: jspb.Message.getBooleanFieldWithDefault(msg, 27, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.Charge}
 */
proto.stockborrowpb.Charge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.Charge;
  return proto.stockborrowpb.Charge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.Charge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.Charge}
 */
proto.stockborrowpb.Charge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStockBorrowId(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFirstBorrowDate(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRate(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 16:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromTradeDate(value);
      break;
    case 17:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToTradeDate(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRateSource(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPrice(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdQty(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdQty(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousRate(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRateId(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowClientRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.Charge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.Charge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.Charge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.Charge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStockBorrowId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFirstBorrowDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFromTradeDate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToTradeDate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getRateSource();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getSdQty();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getPreviousRate();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getRateId();
  if (f !== 0) {
    writer.writeUint32(
      26,
      f
    );
  }
  f = message.getShowClientRate();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
};


/**
 * optional uint32 stock_borrow_id = 1;
 * @return {number}
 */
proto.stockborrowpb.Charge.prototype.getStockBorrowId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setStockBorrowId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.type.Date first_borrow_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.Charge.prototype.getFirstBorrowDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.Charge} returns this
*/
proto.stockborrowpb.Charge.prototype.setFirstBorrowDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.clearFirstBorrowDate = function() {
  return this.setFirstBorrowDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.Charge.prototype.hasFirstBorrowDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Date trade_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.Charge.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.Charge} returns this
*/
proto.stockborrowpb.Charge.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.Charge.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 account_id = 4;
 * @return {number}
 */
proto.stockborrowpb.Charge.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string correspondent = 5;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string original_cusip = 6;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_no = 7;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string symbol = 8;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol_description = 9;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string cusip = 10;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string qty = 11;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string rate = 12;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string fee = 13;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string date_type = 15;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional google.type.Date from_trade_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.Charge.prototype.getFromTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.Charge} returns this
*/
proto.stockborrowpb.Charge.prototype.setFromTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.clearFromTradeDate = function() {
  return this.setFromTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.Charge.prototype.hasFromTradeDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.type.Date to_trade_date = 17;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.Charge.prototype.getToTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 17));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.Charge} returns this
*/
proto.stockborrowpb.Charge.prototype.setToTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.clearToTradeDate = function() {
  return this.setToTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.Charge.prototype.hasToTradeDate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string market_value = 18;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string status = 19;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string rate_source = 20;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getRateSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setRateSource = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string closing_price = 21;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string td_qty = 22;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getTdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setTdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string sd_qty = 23;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getSdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setSdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string previous_rate = 24;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getPreviousRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setPreviousRate = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string asset_type = 25;
 * @return {string}
 */
proto.stockborrowpb.Charge.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional uint32 rate_id = 26;
 * @return {number}
 */
proto.stockborrowpb.Charge.prototype.getRateId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setRateId = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional bool show_client_rate = 27;
 * @return {boolean}
 */
proto.stockborrowpb.Charge.prototype.getShowClientRate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stockborrowpb.Charge} returns this
 */
proto.stockborrowpb.Charge.prototype.setShowClientRate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.ListChargeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.ListChargeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.ListChargeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dateType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fromTradeDate: (f = msg.getFromTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toTradeDate: (f = msg.getToTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.ListChargeRequest}
 */
proto.stockborrowpb.ListChargeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.ListChargeRequest;
  return proto.stockborrowpb.ListChargeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.ListChargeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.ListChargeRequest}
 */
proto.stockborrowpb.ListChargeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 7:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromTradeDate(value);
      break;
    case 8:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToTradeDate(value);
      break;
    case 9:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.ListChargeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.ListChargeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.ListChargeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFromTradeDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToTradeDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cusip = 4;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string date_type = 6;
 * @return {string}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.type.Date from_trade_date = 7;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getFromTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 7));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
*/
proto.stockborrowpb.ListChargeRequest.prototype.setFromTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.clearFromTradeDate = function() {
  return this.setFromTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.ListChargeRequest.prototype.hasFromTradeDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.type.Date to_trade_date = 8;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getToTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 8));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
*/
proto.stockborrowpb.ListChargeRequest.prototype.setToTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.clearToTradeDate = function() {
  return this.setToTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.ListChargeRequest.prototype.hasToTradeDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional utilspb.Pagination pagination = 9;
 * @return {?proto.utilspb.Pagination}
 */
proto.stockborrowpb.ListChargeRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 9));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
*/
proto.stockborrowpb.ListChargeRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.ListChargeRequest} returns this
 */
proto.stockborrowpb.ListChargeRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.ListChargeRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.ListChargeSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.ListChargeSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.ListChargeSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    fee: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tdQty: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sdQty: jspb.Message.getFieldWithDefault(msg, 5, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.ListChargeSummary}
 */
proto.stockborrowpb.ListChargeSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.ListChargeSummary;
  return proto.stockborrowpb.ListChargeSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.ListChargeSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.ListChargeSummary}
 */
proto.stockborrowpb.ListChargeSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdQty(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdQty(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.ListChargeSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.ListChargeSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.ListChargeSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSdQty();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional string fee = 1;
 * @return {string}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_value = 2;
 * @return {string}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string qty = 3;
 * @return {string}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string td_qty = 4;
 * @return {string}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getTdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setTdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sd_qty = 5;
 * @return {string}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getSdQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setSdQty = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 total_rows = 6;
 * @return {number}
 */
proto.stockborrowpb.ListChargeSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.stockborrowpb.ListChargeSummary} returns this
 */
proto.stockborrowpb.ListChargeSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stockborrowpb.ListChargeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.ListChargeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.ListChargeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.ListChargeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chargesList: jspb.Message.toObjectList(msg.getChargesList(),
    proto.stockborrowpb.Charge.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.stockborrowpb.ListChargeSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.ListChargeResponse}
 */
proto.stockborrowpb.ListChargeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.ListChargeResponse;
  return proto.stockborrowpb.ListChargeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.ListChargeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.ListChargeResponse}
 */
proto.stockborrowpb.ListChargeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stockborrowpb.Charge;
      reader.readMessage(value,proto.stockborrowpb.Charge.deserializeBinaryFromReader);
      msg.addCharges(value);
      break;
    case 2:
      var value = new proto.stockborrowpb.ListChargeSummary;
      reader.readMessage(value,proto.stockborrowpb.ListChargeSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.ListChargeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.ListChargeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.ListChargeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ListChargeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stockborrowpb.Charge.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stockborrowpb.ListChargeSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Charge charges = 1;
 * @return {!Array<!proto.stockborrowpb.Charge>}
 */
proto.stockborrowpb.ListChargeResponse.prototype.getChargesList = function() {
  return /** @type{!Array<!proto.stockborrowpb.Charge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stockborrowpb.Charge, 1));
};


/**
 * @param {!Array<!proto.stockborrowpb.Charge>} value
 * @return {!proto.stockborrowpb.ListChargeResponse} returns this
*/
proto.stockborrowpb.ListChargeResponse.prototype.setChargesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stockborrowpb.Charge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stockborrowpb.Charge}
 */
proto.stockborrowpb.ListChargeResponse.prototype.addCharges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stockborrowpb.Charge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stockborrowpb.ListChargeResponse} returns this
 */
proto.stockborrowpb.ListChargeResponse.prototype.clearChargesList = function() {
  return this.setChargesList([]);
};


/**
 * optional ListChargeSummary summary = 2;
 * @return {?proto.stockborrowpb.ListChargeSummary}
 */
proto.stockborrowpb.ListChargeResponse.prototype.getSummary = function() {
  return /** @type{?proto.stockborrowpb.ListChargeSummary} */ (
    jspb.Message.getWrapperField(this, proto.stockborrowpb.ListChargeSummary, 2));
};


/**
 * @param {?proto.stockborrowpb.ListChargeSummary|undefined} value
 * @return {!proto.stockborrowpb.ListChargeResponse} returns this
*/
proto.stockborrowpb.ListChargeResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.ListChargeResponse} returns this
 */
proto.stockborrowpb.ListChargeResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.ListChargeResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.ProcessChargeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.ProcessChargeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.ProcessChargeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ProcessChargeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromTradeDate: (f = msg.getFromTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.ProcessChargeRequest}
 */
proto.stockborrowpb.ProcessChargeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.ProcessChargeRequest;
  return proto.stockborrowpb.ProcessChargeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.ProcessChargeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.ProcessChargeRequest}
 */
proto.stockborrowpb.ProcessChargeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromTradeDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.ProcessChargeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.ProcessChargeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.ProcessChargeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ProcessChargeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromTradeDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Date from_trade_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.stockborrowpb.ProcessChargeRequest.prototype.getFromTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stockborrowpb.ProcessChargeRequest} returns this
*/
proto.stockborrowpb.ProcessChargeRequest.prototype.setFromTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stockborrowpb.ProcessChargeRequest} returns this
 */
proto.stockborrowpb.ProcessChargeRequest.prototype.clearFromTradeDate = function() {
  return this.setFromTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stockborrowpb.ProcessChargeRequest.prototype.hasFromTradeDate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stockborrowpb.ProcessChargeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stockborrowpb.ProcessChargeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stockborrowpb.ProcessChargeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ProcessChargeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stockborrowpb.ProcessChargeResponse}
 */
proto.stockborrowpb.ProcessChargeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stockborrowpb.ProcessChargeResponse;
  return proto.stockborrowpb.ProcessChargeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stockborrowpb.ProcessChargeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stockborrowpb.ProcessChargeResponse}
 */
proto.stockborrowpb.ProcessChargeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stockborrowpb.ProcessChargeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stockborrowpb.ProcessChargeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stockborrowpb.ProcessChargeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stockborrowpb.ProcessChargeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string success = 1;
 * @return {string}
 */
proto.stockborrowpb.ProcessChargeResponse.prototype.getSuccess = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stockborrowpb.ProcessChargeResponse} returns this
 */
proto.stockborrowpb.ProcessChargeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.stockborrowpb);
